function ContactImage() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="400"
      height="301"
      viewBox="0 0 246 185"
      fill="none"
    >
      <path
        d="M245.5 106.387C245.499 90.5077 241.944 74.8299 235.095 60.5034C228.246 46.177 218.277 33.5654 205.919 23.5936C193.561 13.6219 179.128 6.54284 163.678 2.87578C148.227 -0.791282 132.152 -0.953364 116.631 2.40142C101.11 5.75621 86.5373 12.5428 73.9808 22.2633C61.4243 31.9839 51.203 44.3919 44.0665 58.5774C36.93 72.7628 33.0594 88.3657 32.7386 104.242C32.4177 120.118 35.6548 135.865 42.2123 150.327H236.031C242.281 136.522 245.509 121.541 245.5 106.387Z"
        fill="white"
      />
      <path
        d="M35.3778 150.328H242.841"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 150.16L30.2541 150.16"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M119.002 184.877C145.443 184.877 166.878 183.091 166.878 180.888C166.878 178.684 145.443 176.898 119.002 176.898C92.5609 176.898 71.126 178.684 71.126 180.888C71.126 183.091 92.5609 184.877 119.002 184.877Z"
        fill="#F1F9FE"
      />
      <path
        d="M158.792 88.061C147.788 88.061 137.234 92.4326 129.453 100.214C121.671 107.995 117.3 118.549 117.3 129.554V140.725C117.3 161.764 109.826 164.663 101.554 164.663H94.9574V179.026H101.554C113.15 179.026 133.258 169.371 133.258 150.3H184.326C184.326 162.429 175.389 164.663 168.58 164.663H161.984V179.026H168.58C181.666 179.026 200.285 176.366 200.285 150.3V129.554C200.288 124.104 199.218 118.707 197.134 113.671C195.05 108.635 191.994 104.06 188.14 100.206C184.286 96.3525 179.711 93.2963 174.675 91.2124C169.639 89.1284 164.242 88.0575 158.792 88.061Z"
        fill="white"
      />
      <path
        d="M158.792 88.061C147.788 88.061 137.234 92.4326 129.453 100.214C121.671 107.995 117.3 118.549 117.3 129.554V140.725C117.3 161.764 109.826 164.663 101.554 164.663H94.9574V179.026H101.554C113.15 179.026 133.258 169.371 133.258 150.3H184.326C184.326 162.429 175.389 164.663 168.58 164.663H161.984V179.026H168.58C181.666 179.026 200.285 176.366 200.285 150.3V129.554C200.288 124.104 199.218 118.707 197.134 113.671C195.05 108.635 191.994 104.06 188.14 100.206C184.286 96.3525 179.711 93.2963 174.675 91.2124C169.639 89.1284 164.242 88.0575 158.792 88.061Z"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M168.369 89.6556L158.794 96.0391L149.218 89.6556V81.6763H168.369V89.6556Z"
        fill="white"
      />
      <path
        d="M168.369 89.6556L158.794 96.0391L149.218 89.6556V81.6763H168.369V89.6556Z"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M158.792 96.0403L151.106 142.347C150.932 143.363 151.09 144.408 151.558 145.326L154.031 150.3H163.607L166.107 145.326C166.565 144.405 166.714 143.36 166.532 142.347L158.792 96.0403Z"
        fill="#E3F1FC"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M171.533 103.408L178.767 93.0881C175.641 91.3779 172.306 90.0815 168.846 89.2314L158.792 95.9341L167.915 103.754C168.171 103.978 168.471 104.147 168.794 104.251C169.118 104.355 169.46 104.393 169.798 104.36C170.137 104.328 170.466 104.227 170.764 104.063C171.062 103.899 171.324 103.676 171.533 103.408Z"
        fill="white"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M146.053 103.408L138.819 93.0881C141.947 91.3825 145.281 90.0863 148.74 89.2314L158.794 95.9341L149.697 103.754C149.161 104.174 148.484 104.372 147.806 104.307C147.128 104.243 146.501 103.921 146.053 103.408Z"
        fill="white"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M133.26 131.149V150.299"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M184.325 131.149V150.299"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M161.985 177.429H157.197C155.504 177.429 153.88 176.757 152.683 175.56C151.486 174.363 150.813 172.739 150.813 171.046C150.813 169.353 151.486 167.729 152.683 166.532C153.88 165.335 155.504 164.662 157.197 164.662H161.985V177.429Z"
        fill="white"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M94.9572 177.429H90.1696C88.4766 177.429 86.8529 176.757 85.6558 175.56C84.4586 174.363 83.7861 172.739 83.7861 171.046C83.7861 169.353 84.4586 167.729 85.6558 166.532C86.8529 165.335 88.4766 164.662 90.1696 164.662H94.9572V177.429Z"
        fill="white"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M185.922 52.9508V46.5673C185.922 39.3721 183.064 32.4715 177.976 27.3836C172.888 22.2958 165.988 19.4375 158.792 19.4375C151.597 19.4375 144.696 22.2958 139.609 27.3836C134.521 32.4715 131.662 39.3721 131.662 46.5673V52.9508C130.395 52.9578 129.181 53.4645 128.285 54.3608C127.389 55.2572 126.882 56.4709 126.875 57.7385V59.3343C126.882 60.6019 127.389 61.8156 128.285 62.712C129.181 63.6083 130.395 64.115 131.662 64.122H132.115C133.222 70.3966 136.504 76.0806 141.385 80.1759C146.266 84.2712 152.434 86.5159 158.806 86.5159C165.177 86.5159 171.345 84.2712 176.226 80.1759C181.107 76.0806 184.39 70.3966 185.497 64.122H185.922C187.192 64.122 188.41 63.6175 189.308 62.7197C190.205 61.8218 190.71 60.6041 190.71 59.3343V57.7385C190.71 56.4687 190.205 55.2509 189.308 54.3531C188.41 53.4552 187.192 52.9508 185.922 52.9508Z"
        fill="white"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M142.834 67.3137C144.596 67.3137 146.025 65.8847 146.025 64.1219C146.025 62.3592 144.596 60.9302 142.834 60.9302C141.071 60.9302 139.642 62.3592 139.642 64.1219C139.642 65.8847 141.071 67.3137 142.834 67.3137Z"
        fill="#E3F1FC"
      />
      <path
        d="M174.751 67.3137C176.514 67.3137 177.943 65.8847 177.943 64.1219C177.943 62.3592 176.514 60.9302 174.751 60.9302C172.988 60.9302 171.559 62.3592 171.559 64.1219C171.559 65.8847 172.988 67.3137 174.751 67.3137Z"
        fill="#E3F1FC"
      />
      <path
        d="M150.813 70.5061C152.965 72.555 155.822 73.6979 158.793 73.6979C161.764 73.6979 164.621 72.555 166.772 70.5061"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M173.157 56.1437C172.806 55.3727 172.246 54.7153 171.541 54.2453C170.836 53.7754 170.014 53.5117 169.167 53.4839C168.322 53.5177 167.502 53.7838 166.799 54.253C166.095 54.7223 165.534 55.3764 165.178 56.1437"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M152.408 55.6107C152.075 54.828 151.519 54.1605 150.81 53.6913C150.101 53.2221 149.269 52.9719 148.418 52.9719C147.568 52.9719 146.736 53.2221 146.027 53.6913C145.317 54.1605 144.761 54.828 144.429 55.6107"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M136.45 57.7385C137.433 54.0528 137.632 50.2019 137.035 46.4344C139.694 47.3653 144.429 43.3757 144.429 43.3757V36.9922C149.078 38.6061 153.897 39.6771 158.792 40.1839C163.687 39.6812 168.507 38.61 173.155 36.9922V43.3757C173.155 43.3757 177.783 47.3653 180.575 46.4344C179.962 50.1997 180.153 54.052 181.134 57.7385C181.146 56.9957 181.333 56.2662 181.68 55.609C182.026 54.9519 182.523 54.3854 183.128 53.9556C183.734 53.5258 184.433 53.2445 185.168 53.1347C185.902 53.0248 186.653 53.0894 187.358 53.3233C186.88 53.1511 186.376 53.0611 185.868 53.0573V46.6738C185.868 39.4785 183.01 32.5779 177.922 27.4901C172.834 22.4023 165.934 19.5439 158.739 19.5439C151.543 19.5439 144.643 22.4023 139.555 27.4901C134.467 32.5779 131.609 39.4785 131.609 46.6738V53.0573C131.101 53.0655 130.598 53.1553 130.119 53.3233C130.83 53.0622 131.594 52.9766 132.345 53.0737C133.097 53.1709 133.814 53.4479 134.435 53.8813C135.056 54.3147 135.564 54.8917 135.915 55.5632C136.265 56.2347 136.449 56.9809 136.45 57.7385Z"
        fill="white"
      />
      <path
        d="M136.45 57.7385C137.433 54.0528 137.632 50.2019 137.035 46.4344C139.694 47.3653 144.429 43.3757 144.429 43.3757V36.9922C149.078 38.6061 153.897 39.6771 158.792 40.1839C163.687 39.6812 168.507 38.61 173.155 36.9922V43.3757C173.155 43.3757 177.783 47.3653 180.575 46.4344C179.962 50.1997 180.153 54.052 181.134 57.7385C181.146 56.9957 181.333 56.2662 181.68 55.609C182.026 54.9519 182.523 54.3855 183.128 53.9556C183.734 53.5258 184.433 53.2445 185.168 53.1347C185.902 53.0248 186.653 53.0894 187.358 53.3233C186.88 53.1511 186.376 53.0611 185.868 53.0573V46.6738C185.868 39.4785 183.01 32.5779 177.922 27.4901C172.834 22.4023 165.934 19.5439 158.739 19.5439C151.543 19.5439 144.643 22.4023 139.555 27.4901C134.467 32.5779 131.609 39.4785 131.609 46.6738V53.0573C131.101 53.0655 130.598 53.1553 130.119 53.3233C130.83 53.0622 131.594 52.9766 132.345 53.0737C133.097 53.1709 133.814 53.4479 134.435 53.8813C135.056 54.3147 135.564 54.8917 135.915 55.5632C136.265 56.2347 136.449 56.9809 136.45 57.7385Z"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M126.875 64.123V68.9107C126.875 72.7199 128.388 76.3732 131.082 79.0667C133.775 81.7603 137.428 83.2735 141.238 83.2735H142.834"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M123.683 56.1428V48.1634C123.683 38.8519 127.382 29.9217 133.967 23.3374C140.551 16.7532 149.481 13.0542 158.793 13.0542C168.104 13.0542 177.034 16.7532 183.619 23.3374C190.203 29.9217 193.902 38.8519 193.902 48.1634V54.5469"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M123.682 51.3552H130.066V67.314H123.682C122.836 67.314 122.024 66.9777 121.425 66.3791C120.827 65.7805 120.49 64.9687 120.49 64.1222V54.547C120.49 53.7005 120.827 52.8886 121.425 52.2901C122.024 51.6915 122.836 51.3552 123.682 51.3552Z"
        fill="white"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M126.875 64.1222C126.875 64.9687 127.211 65.7805 127.81 66.3791C128.408 66.9777 129.22 67.314 130.067 67.314C130.913 67.314 131.725 66.9777 132.324 66.3791C132.922 65.7805 133.258 64.9687 133.258 64.1222V54.547C133.258 53.7005 132.922 52.8886 132.324 52.2901C131.725 51.6915 130.913 51.3552 130.067 51.3552C129.22 51.3552 128.408 51.6915 127.81 52.2901C127.211 52.8886 126.875 53.7005 126.875 54.547V64.1222Z"
        fill="#E3F1FC"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.903 67.3137H187.519V51.355H193.903C194.749 51.355 195.561 51.6913 196.16 52.2898C196.758 52.8884 197.094 53.7002 197.094 54.5467V64.122C197.094 64.9685 196.758 65.7803 196.16 66.3789C195.561 66.9775 194.749 67.3137 193.903 67.3137Z"
        fill="white"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M190.709 64.1222C190.709 64.9687 190.373 65.7805 189.774 66.3791C189.175 66.9777 188.364 67.314 187.517 67.314C186.671 67.314 185.859 66.9777 185.26 66.3791C184.662 65.7805 184.325 64.9687 184.325 64.1222V54.547C184.325 53.7005 184.662 52.8886 185.26 52.2901C185.859 51.6915 186.671 51.3552 187.517 51.3552C188.364 51.3552 189.175 51.6915 189.774 52.2901C190.373 52.8886 190.709 53.7005 190.709 54.547V64.1222Z"
        fill="#E3F1FC"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M152.409 83.2735C152.409 84.2204 152.128 85.146 151.602 85.9333C151.076 86.7206 150.329 87.3343 149.454 87.6967C148.579 88.059 147.616 88.1538 146.688 87.9691C145.759 87.7844 144.906 87.3284 144.236 86.6588C143.567 85.9893 143.111 85.1362 142.926 84.2075C142.741 83.2788 142.836 82.3161 143.198 81.4413C143.561 80.5665 144.174 79.8188 144.962 79.2927C145.749 78.7666 146.675 78.4858 147.622 78.4858C148.891 78.4858 150.109 78.9903 151.007 79.8881C151.905 80.786 152.409 82.0037 152.409 83.2735Z"
        fill="#E3F1FC"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M128.815 172.882H134.746L122.059 133.517C121.885 132.983 121.547 132.519 121.093 132.189C120.64 131.86 120.093 131.682 119.532 131.681H115.516L128.815 172.882Z"
        fill="#E3F1FC"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M76.9506 172.88H128.816L115.518 131.654H67.2956C66.8759 131.652 66.4619 131.751 66.0875 131.94C65.713 132.13 65.3887 132.405 65.1411 132.744C64.894 133.085 64.7313 133.48 64.6666 133.896C64.6018 134.312 64.6369 134.738 64.7688 135.138L76.9506 172.88Z"
        fill="#E3F1FC"
      />
      <path
        d="M76.949 172.881H131.475V179.53H82.2686C80.8578 179.53 79.5047 178.97 78.5071 177.972C77.5095 176.975 76.949 175.622 76.949 174.211V172.881Z"
        fill="#E3F1FC"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M131.475 172.881H155.546C155.899 172.881 156.237 173.021 156.487 173.27C156.736 173.52 156.876 173.858 156.876 174.211C156.876 175.622 156.316 176.975 155.318 177.972C154.321 178.97 152.968 179.53 151.557 179.53H131.475V172.881Z"
        fill="#E3F1FC"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M76.9506 172.88H128.816L115.518 131.654H67.2956C66.8759 131.652 66.4619 131.751 66.0875 131.94C65.713 132.13 65.3887 132.405 65.1411 132.744C64.894 133.085 64.7313 133.48 64.6666 133.896C64.6018 134.312 64.6369 134.738 64.7688 135.138L76.9506 172.88Z"
        stroke="#1974BF"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default ContactImage;
